import { Purchase } from './purchase';
import { Wishlist } from './wishlist';

export type USER_STATUS = 'active' | 'suspended';
export enum USER_STATUS_ENUM {
  active = 'active',
  suspended = 'suspended',
}

export type USER_ROLE = 'admin' | 'user';
export enum USER_ROLE_ENUM {
  admin = 'admin',
  user = 'user',
}

export interface User {
  id: string;
  name: string;
  email: string;
  phone?: string;
  password: string;
  status?: USER_STATUS;
  role: USER_ROLE;
  purchases: Purchase[];
  wishlist: Wishlist[];
  createdAt: Date;
  updatedAt: Date;
}